import Award from "../images/award.svg";
import Rocket from "../images/rocket.svg";
import Trusted from "../images/trusted.svg";

export const features = [
  {
    title: "Award-Winning",
    img: Award,
    copy: "Et obcaecati iure qui fugit delectus ab sunt error et deserunt sint et nesciunt voluptas sed debitis dignissimos. ",
  },
  {
    title: "Advanced Technology",
    img: Rocket,
    copy: "Et obcaecati iure qui fugit delectus ab sunt error et deserunt sint et nesciunt voluptas sed debitis dignissimos. ",
  },
  {
    title: "Trusted",
    img: Trusted,
    copy: "Et obcaecati iure qui fugit delectus ab sunt error et deserunt sint et nesciunt voluptas sed debitis dignissimos. ",
  },
];
